import React from "react";

import AlbumsContainer from "../../modules/OrganizationAlbums/containers/AlbumsContainer/AlbumsContainer";

const AlbumsInOrg = () => {
  return <AlbumsContainer />;
};

export default AlbumsInOrg;
